import React, { createContext, useLayoutEffect, useMemo, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Backdrop from '@material-ui/core/Backdrop';
import { _ParentFrame } from '../../../src/Frame/types/Frame';
export const BackdropContext = createContext({
    show: () => { },
    hide: () => { },
});
const useStyles = makeStyles({
    root: { zIndex: 9999 }
}, { name: "BackdropProvider" });
/**
 * Провайдер бэкдропа для операций требующих полной блокировки пользовательского интерфейса.
 */
export function BackdropProvider(props) {
    const classes = useStyles();
    const [isVisible, setVisible] = useState(0);
    const handlers = useMemo(() => ({
        show: () => setVisible(o => o + 1),
        hide: () => setVisible(o => Math.max(0, o - 1)),
    }), []);
    useLayoutEffect(() => {
        if (!props.isFrame)
            return;
        const parentFrame = _ParentFrame();
        if (!parentFrame)
            return;
        parentFrame.sendMessage({ message: isVisible ? 'open-backdrop' : 'hide-backdrop' });
    }, [isVisible, props.isFrame]);
    return (React.createElement(BackdropContext.Provider, { value: handlers }, props.isFrame ? React.createElement(React.Fragment, null, props.children) : React.createElement(React.Fragment, null,
        React.createElement(Backdrop, { open: isVisible > 0, unmountOnExit: true, mountOnEnter: true, className: classes.root },
            React.createElement("span", { id: "spiner", className: "fa fa-spinner fa-pulse fa-4x text-info" })),
        props.children)));
}
